import React, { useState, useEffect, useRef } from 'react'
import XYAxis from '../docs/xy-axis.js'
import Logo from '../imgs/Culpepper-Logo-2024.svg'
import axios from 'axios'
import Chart from '../docs/chart'
import { Col, Container, Row } from 'react-bootstrap'
import {
    TEXT_REPORT_SELECTION,
    TEXT_DATA_CUTS_SELECTION,
    TEXT_OWNERSHIP,
    TEXT_STARTUP,
    TEXT_HEADCOUNT,
    TEXT_INDUSTRY_VERTICAL,
    TEXT_INDUSTRY_SECTOR,
    TEXT_INDUSTRY_SECTOR_SPECIALTY,
    INDUSTRY_SECTOR_LABEL_SURVEY_LIST,
    SURVEY_UUID_LIST,
    MIN_SAMPLE_SIZE,
    TEXT_SELECT_PLACEHOLDER,
    TEXT_COUNTRY_SELECTION,
    COUNTRY_SELECTED_TEXT,
    TEXT_NO_AVAIL_DATA,
    YEAR_DATA_CUT_SELECTED_NAME,
    JOB_FUNCTION_DATA_CUT_SELECTED_NAME,
    SURVEY_COPY_RIGHT,
    SURVEY_YEAR_2023,
    SURVEY_YEAR_2023_2024,
    SURVEY_YEAR_2024,
    SURVEY_YEAR_2024_2025,
    SURVEY_YEAR_2025,
    SURVEY_YEAR_2025_2026,
    SURVEY_YEAR_2025_2026_PRELIM,
    SURVEY_YEAR_2026_PRELIM,
    SURVEY_YEAR_2026,
    SURVEY_YEAR_2026_2027_PRELIM,
    SURVEY_YEAR_2026_2027,
    SURVEY_YEAR_2027_PRELIM,
    TEXT_PARTICIPATION,
    DISALLOW_RECENT_SURVEY_SELECTION,
    VERTICAL_FILTER_AVAILABLE_SURVEY_LIST,
    STARTUP_FILTER_AVAILABLE_SURVEY_LIST,
    SURVEY_EFFECTIVE_DATE_LIST,
    SURVEY_EFFECTIVE_DATE_1MONTH_PRIOR_LIST,
    SURVEY_EFFECTIVE_DATE_2MONTHS_PRIOR_LIST,
    SURVEY_EFFECTIVE_DATE_3MONTHS_PRIOR_LIST,
    SURVEY_EFFECTIVE_DATE_4MONTHS_PRIOR_LIST,
    SURVEY_EFFECTIVE_DATE_ALL_DATA_LIST,
} from '../constants/constants'
import {
    SECTOR_GROUPS,
    SECTOR_GROUPS_2026,
    SECTOR_GROUPS_2026_2027,
    SECTOR_GROUPS_2027,
    VERTICALS,
    VERTICALS_2025_2026,
    VERTICALS_2026,
    OWNERSHIP_GROUPS,
    HEADCOUNT_OPTIONS,
    STARTUP_OPTIONS,
    YEARS,
    JOB_FUNCTIONS,
    HEADCOUNT_OPTIONS_2024_2025,
    HEADCOUNT_OPTIONS_2025_2026,
} from '../constants/datacutConstants'
import {
    PRACTICE_REPORT_OPTIONS,
    STI_TYPE,
    LTI_TYPE,
    STI_PERCENT,
    STI_TYPE_COLUMN_NAME,
    LTI_TYPE_COLUMN_NAME,
    STI_BUDGETS_COLUMN_NAME,
} from '../constants/practiceReportOptionConstants'
import {
    useQueryState,
    getTotalResponse,
    ReactSelect,
    IsValidDataCutSelection,
    getDataCutSelectionTextTitle,
    getDataCutSelectionTextName,
    tableFooter,
    formatDateMonthDay,
    formatDateYearMonthDay,
    createNotReportableOptionFormatter,
    createNotReportableOptionDisabler,
} from '../helpers/helpers'
import { REACT_APP_SERVER_ADDRESS } from '../config'
import PageNotFound from './404Page'
import { useParams } from 'react-router-dom'
import { formatGroupLabel } from '../docs/style'
import { PRACTICE_GROUPED_COUNTRY_OPTIONS } from '../constants/practiceCountryConstants'

function Practice() {
    return (
        <div>
            <UserInput />
        </div>
    )
}

const PRACTICE_REPORT_GROUPS_2026_2027 = [
    {
        label: 'Use of AI in Salary Budgeting and Compensation Planning',
        values: [
            'AI_usage_status',
            'AI_use_cases',
            'AI_nonuse_reasons',
            'AI_future_plans',
        ],
    },
    {
        label: 'Base Pay Increases',
        values: ['ReviewFrequency_Select', 'BasePayFactors'],
    },
    {
        label: 'Salary Structures',
        values: ['Structure', 'StructureFrequencySelect'],
    },
    {
        label: 'Short-Term Cash Incentives',
        values: ['STI_Choice', STI_TYPE],
    },
    {
        label: 'Long-Term Incentives',
        values: ['LTI_Choice', LTI_TYPE],
    },
]

const flattenReportOptions = (options) =>
    options.reduce(
        (acc, option) => acc.concat(option.options ? option.options : option),
        []
    )

const getPracticeReportOptions = (survey) => {
    const reportOptions = PRACTICE_REPORT_OPTIONS[survey]

    if (![SURVEY_YEAR_2026_2027, SURVEY_YEAR_2027_PRELIM].includes(survey)) {
        return reportOptions
    }

    return PRACTICE_REPORT_GROUPS_2026_2027.map((group) => ({
        label: group.label,
        options: group.values
            .map((value) =>
                reportOptions.find((option) => option.value === value)
            )
            .filter(Boolean),
    }))
}

const UserInput = () => {
    const params = useParams()
    const survey = SURVEY_UUID_LIST[params.survey]
    const sectorGroups = [SURVEY_YEAR_2027_PRELIM].includes(survey)
        ? SECTOR_GROUPS_2027
        : [SURVEY_YEAR_2026_2027_PRELIM, SURVEY_YEAR_2026_2027].includes(survey)
        ? SECTOR_GROUPS_2026_2027
        : DISALLOW_RECENT_SURVEY_SELECTION.includes(survey)
        ? SECTOR_GROUPS
        : SECTOR_GROUPS_2026
    const sectorLabel = INDUSTRY_SECTOR_LABEL_SURVEY_LIST.includes(survey)
        ? TEXT_INDUSTRY_SECTOR
        : TEXT_INDUSTRY_SECTOR_SPECIALTY
    const [countryValue, setCountryValue] = useQueryState('country')
    const [reportValue, setReportValue] = useQueryState('report')
    const [yearValue, setYearValue] = useQueryState('year')
    const [jobFunctionValue, setJobFunctionValue] = useQueryState('jobfunction')
    const [sectorValue, setSectorValue] = useQueryState('sector')
    const isVerticalFilterAvailable =
        VERTICAL_FILTER_AVAILABLE_SURVEY_LIST.includes(survey)
    const [verticalQueryValue, setVerticalValue] = useQueryState('vertical')
    const verticalValue = isVerticalFilterAvailable ? verticalQueryValue : null
    const [ownershipValue, setOwnershipValue] = useQueryState('ownership')
    const [headcountValue, setHeadcountValue] = useQueryState('headcount')
    const isStartupFilterAvailable =
        STARTUP_FILTER_AVAILABLE_SURVEY_LIST.includes(survey)
    const [startupQueryValue, setStartupValue] = useQueryState('startup')
    const startupValue = isStartupFilterAvailable ? startupQueryValue : null

    const [cutoff, setCutoff] = useQueryState('cutoffDate')
    const [cutoffDateText, setCutoffDateText] = useState(null)

    const [headcountOptions, setHeadcountOptions] = useState(HEADCOUNT_OPTIONS)
    useEffect(() => {
        if (
            [
                SURVEY_YEAR_2023,
                SURVEY_YEAR_2023_2024,
                SURVEY_YEAR_2024,
            ].includes(survey)
        ) {
            setHeadcountOptions(HEADCOUNT_OPTIONS)
        } else if ([SURVEY_YEAR_2024_2025, SURVEY_YEAR_2025].includes(survey)) {
            setHeadcountOptions(HEADCOUNT_OPTIONS_2024_2025)
        } else {
            setHeadcountOptions(HEADCOUNT_OPTIONS_2025_2026)
        }
    }, [survey])
    const [reportName, setReportName] = useState('')
    const [reportQuestion, setReportQuestion] = useState('')
    const [items, setItems] = useState([])
    const [allItems, setAllItems] = useState([])
    const [reportability, setReportability] = useState({})
    const [responseTotal, setResponseTotal] = useState()
    const [maxPercent, setMaxPercent] = useState(100)

    const [ongoingRequests, setOngoingRequests] = useState(0)
    const reportOptions = getPracticeReportOptions(survey)
    const flatReportOptions = flattenReportOptions(reportOptions)

    useEffect(() => {
        clearDataChart()
        handleReportValueChange()

        if (
            (reportValue !== STI_PERCENT &&
                reportValue !== STI_TYPE &&
                reportValue !== LTI_TYPE &&
                yearValue === undefined &&
                jobFunctionValue === undefined) ||
            (reportValue === STI_PERCENT && yearValue !== undefined) ||
            ((reportValue === STI_TYPE || reportValue === LTI_TYPE) &&
                jobFunctionValue !== undefined)
        ) {
            fetchDataAndUpdateChart()
        }
    }, [
        countryValue,
        reportValue,
        sectorValue,
        verticalValue,
        ownershipValue,
        headcountValue,
        startupValue,
        cutoff,
        yearValue,
        jobFunctionValue,
    ])

    useEffect(() => {
        if (!isPracticeQueryReady()) {
            setReportability({})
            return
        }

        if (shouldUseStandaloneReportabilityFetch()) {
            fetchReportability()
        }
    }, [
        countryValue,
        reportValue,
        sectorValue,
        verticalValue,
        ownershipValue,
        headcountValue,
        startupValue,
        cutoff,
        yearValue,
        jobFunctionValue,
    ])

    const handleReportValueChange = () => {
        if (reportValue === STI_PERCENT) {
            if (yearValue === undefined) {
                setYearValue('AllYears')
            }
            if (jobFunctionValue !== undefined) {
                setJobFunctionValue(undefined)
            }
        } else if (reportValue === STI_TYPE || reportValue === LTI_TYPE) {
            if (jobFunctionValue === undefined) {
                setJobFunctionValue('All')
            }
            if (yearValue !== undefined) {
                setYearValue(undefined)
            }
        } else {
            if (jobFunctionValue !== undefined) {
                setJobFunctionValue(undefined)
            }
            if (yearValue !== undefined) {
                setYearValue(undefined)
            }
        }
    }

    useEffect(() => {
        if (cutoff !== undefined && cutoff !== null) {
            const matchingOption = getRecentDateOptions().find(
                (opt) => opt.milliseconds === Number(cutoff)
            )
            if (matchingOption) {
                setCutoffDateText(matchingOption.label)
            } else {
                setCutoffDateText(null)
            }
        } else {
            setCutoffDateText(null)
        }
    }, [cutoff])

    useEffect(() => {
        updateReportQuestionName()
    }, [reportValue])

    const clearDataChart = () => {
        setResponseTotal(undefined)
    }

    useEffect(() => {
        if (items.length > 0) {
            setMaxPercent(Math.max(...items.map((item) => item.percent)))
        }
    }, [items])

    const isPracticeQueryReady = () => {
        if (!reportValue) {
            return false
        }

        return (
            (reportValue !== STI_PERCENT &&
                reportValue !== STI_TYPE &&
                reportValue !== LTI_TYPE &&
                yearValue === undefined &&
                jobFunctionValue === undefined) ||
            (reportValue === STI_PERCENT && yearValue !== undefined) ||
            ((reportValue === STI_TYPE || reportValue === LTI_TYPE) &&
                jobFunctionValue !== undefined)
        )
    }

    const shouldUseStandaloneReportabilityFetch = () => {
        return jobFunctionValue === 'All' || yearValue === 'AllYears'
    }

    const fetchReportability = async () => {
        const options = {
            method: 'GET',
            url: `${REACT_APP_SERVER_ADDRESS}practice`,
            params: {
                country: countryValue,
                report: reportValue,
                sector: sectorValue,
                vertical: verticalValue,
                ownership: ownershipValue,
                headcount: headcountValue,
                startup: startupValue,
                survey: survey,
                year: yearValue,
                jobfunction: jobFunctionValue,
                cutoff: !cutoff || cutoff === 'undefined' ? 0 : cutoff,
            },
        }

        try {
            const response = await axios.request(options)
            setReportability(response.data.reportability || {})
        } catch (e) {
            setReportability({})
        }
    }

    const fetchDataAndUpdateChart = async () => {
        if (reportValue) {
            if (jobFunctionValue !== 'All' && yearValue !== 'AllYears') {
                const options = {
                    method: 'GET',
                    url: `${REACT_APP_SERVER_ADDRESS}practice`,
                    params: {
                        country: countryValue,
                        report: reportValue,
                        sector: sectorValue,
                        vertical: verticalValue,
                        ownership: ownershipValue,
                        headcount: headcountValue,
                        startup: startupValue,
                        survey: survey,
                        year: yearValue,
                        jobfunction: jobFunctionValue,
                        cutoff: !cutoff || cutoff === 'undefined' ? 0 : cutoff,
                    },
                }

                try {
                    setOngoingRequests((ongoingRequests) => ongoingRequests + 1)
                    const response = await axios.request(options)
                    const respBody = response.data
                    const newData = respBody.results
                    setReportability(respBody.reportability || {})
                    //loop through each object in list newData and check the value of attribute genre and if it is 'Employee Stock Purchase Plan (ESSP)', replace it with 'Employee Stock Purchase Plan (ESPP)'
                    for (const [key, value] of Object.entries(newData)) {
                        if (
                            value['genre'] ===
                            'Employee Stock Purchase Plan (ESSP)'
                        ) {
                            value['genre'] =
                                'Employee Stock Purchase Plan (ESPP)'
                        }
                    }
                    setResponseTotal(getTotalResponse(newData))
                    setItems(newData)
                } catch (e) {
                } finally {
                    setOngoingRequests((ongoingRequests) => ongoingRequests - 1)
                }
            } else if (jobFunctionValue === 'All') {
                const tempList = []
                // loop through the value of json object in list JOB_FUNCTIONS and print value, exclude the value 'All'
                for (const [key, value] of Object.entries(JOB_FUNCTIONS)) {
                    if (value['value'] !== 'All') {
                        const options = {
                            method: 'GET',
                            url: `${REACT_APP_SERVER_ADDRESS}practice`,
                            params: {
                                country: countryValue,
                                report: reportValue,
                                sector: sectorValue,
                                vertical: verticalValue,
                                ownership: ownershipValue,
                                headcount: headcountValue,
                                startup: startupValue,
                                survey: survey,
                                year: yearValue,
                                jobfunction: value['value'],
                                cutoff:
                                    !cutoff || cutoff === 'undefined'
                                        ? 0
                                        : cutoff,
                            },
                        }

                        try {
                            setOngoingRequests(
                                (ongoingRequests) => ongoingRequests + 1
                            )
                            const response = await axios.request(options)
                            const respBody = response.data
                            const newData = respBody.results
                            //loop through each object in list newData and check the value of attribute genre and if it is 'Employee Stock Purchase Plan (ESSP)', replace it with 'Employee Stock Purchase Plan (ESPP)'
                            // for (const [key, value] of Object.entries(
                            //     newData
                            // )) {
                            //     if (
                            //         value['genre'] ===
                            //         'Employee Stock Purchase Plan (ESSP)'
                            //     ) {
                            //         value['genre'] =
                            //             'Employee Stock Purchase Plan (ESPP)'
                            //     }
                            // }
                            const jobFunctionResponseTotal =
                                getTotalResponse(newData)
                            const matchingLabel = JOB_FUNCTIONS.find(
                                (jobFunction) =>
                                    jobFunction.value === value['value']
                            )
                            const resultDict = {
                                // map value['value'] to the value of json object in list JOB_FUNCTIONS and return the corresponding label
                                category: matchingLabel.tableHeader,
                                data: newData,
                                responseTotal: jobFunctionResponseTotal,
                            }
                            tempList.push(resultDict)
                        } catch (e) {
                        } finally {
                            setOngoingRequests(
                                (ongoingRequests) => ongoingRequests - 1
                            )
                        }
                    }
                }
                setAllItems(tempList)

                // check if responseTotal of each object in list tempList is less than MIN_SAMPLE_SIZE, if yes, set responseTotal to 0, else set responseTotal to 'showDataTable'
                let count = 0
                for (const [key, value] of Object.entries(tempList)) {
                    if (value['responseTotal'] < MIN_SAMPLE_SIZE) {
                        count++
                    }
                }
                if (count === tempList.length) {
                    setResponseTotal(0)
                } else {
                    setResponseTotal('showDataTable')
                }
            } else if (yearValue === 'AllYears') {
                const tempList = []
                // loop through the value of json object in list YEARS and print value, exclude the value 'All'
                for (const [key, value] of Object.entries(YEARS)) {
                    if (value['value'] !== 'AllYears') {
                        const options = {
                            method: 'GET',
                            url: `${REACT_APP_SERVER_ADDRESS}practice`,
                            params: {
                                country: countryValue,
                                report: reportValue,
                                sector: sectorValue,
                                vertical: verticalValue,
                                ownership: ownershipValue,
                                headcount: headcountValue,
                                startup: startupValue,
                                survey: survey,
                                jobfunction: jobFunctionValue,
                                year: value['value'],
                                cutoff:
                                    !cutoff || cutoff === 'undefined'
                                        ? 0
                                        : cutoff,
                            },
                        }

                        try {
                            setOngoingRequests(
                                (ongoingRequests) => ongoingRequests + 1
                            )
                            const response = await axios.request(options)
                            const respBody = response.data
                            const newData = respBody.results
                            const yearResponseTotal = getTotalResponse(newData)
                            const matchingLabel = YEARS.find(
                                (yearValue) =>
                                    yearValue.value === value['value']
                            )
                            const resultDict = {
                                // map value['value'] to the value of json object in list JOB_FUNCTIONS and return the corresponding label
                                category: matchingLabel.tableHeader,
                                data: newData,
                                responseTotal: yearResponseTotal,
                            }
                            tempList.push(resultDict)
                        } catch (e) {
                        } finally {
                            setOngoingRequests(
                                (ongoingRequests) => ongoingRequests - 1
                            )
                        }
                    }
                }
                setAllItems(tempList)

                // check if responseTotal of each object in list tempList is less than MIN_SAMPLE_SIZE, if yes, set responseTotal to 0, else set responseTotal to 'showDataTable'
                let count = 0
                for (const [key, value] of Object.entries(tempList)) {
                    if (value['responseTotal'] < MIN_SAMPLE_SIZE) {
                        count++
                    }
                }
                if (count === tempList.length) {
                    setResponseTotal(0)
                } else {
                    setResponseTotal('showDataTable')
                }
            }
        }
    }

    // Convert string to Date and then get milliseconds
    const effectiveDate = new Date(SURVEY_EFFECTIVE_DATE_LIST[survey])
    const oneMonthPrior = new Date(
        SURVEY_EFFECTIVE_DATE_1MONTH_PRIOR_LIST[survey]
    )
    const twoMonthsPrior = new Date(
        SURVEY_EFFECTIVE_DATE_2MONTHS_PRIOR_LIST[survey]
    )
    const threeMonthsPrior = new Date(
        SURVEY_EFFECTIVE_DATE_3MONTHS_PRIOR_LIST[survey]
    )
    const fourMonthsPrior = new Date(
        SURVEY_EFFECTIVE_DATE_4MONTHS_PRIOR_LIST[survey]
    )

    const allDataDate = new Date(SURVEY_EFFECTIVE_DATE_ALL_DATA_LIST[survey])

    const getRecentDateOptions = () => {
        const buildOption = (date, isTrailingAnnual = false) => ({
            label: isTrailingAnnual
                ? `${formatDateYearMonthDay(
                      date
                  )} through ${formatDateYearMonthDay(
                      effectiveDate
                  )} (Trailing Annual)`
                : `${formatDateYearMonthDay(
                      date
                  )} through ${formatDateYearMonthDay(effectiveDate)}`,
            value: formatDateYearMonthDay(date), // Store formatted date as value for display
            milliseconds: date.getTime(), // Send the date in milliseconds (for backend)
        })

        let dates = []

        if (survey === SURVEY_YEAR_2025_2026) {
            dates = [oneMonthPrior, threeMonthsPrior, fourMonthsPrior]
        } else if (survey === SURVEY_YEAR_2025_2026_PRELIM) {
            dates = [
                oneMonthPrior,
                twoMonthsPrior,
                threeMonthsPrior,
                fourMonthsPrior,
            ]
        } else if (survey === SURVEY_YEAR_2026_PRELIM) {
            dates = [twoMonthsPrior]
        } else if (survey === SURVEY_YEAR_2026) {
            return [
                buildOption(threeMonthsPrior),
                buildOption(allDataDate, true),
                buildOption(twoMonthsPrior),
            ]
        } else if (
            [SURVEY_YEAR_2026_2027_PRELIM, SURVEY_YEAR_2026_2027].includes(
                survey
            )
        ) {
            dates = [oneMonthPrior, twoMonthsPrior]
        } else if (survey === SURVEY_YEAR_2027_PRELIM) {
            dates = [oneMonthPrior]
        }

        return [
            ...dates.map((date) => buildOption(date)),
            buildOption(allDataDate, true), // trailing Annual option
        ]
    }

    const handleRecentDataChange = (selected) => {
        if (selected) {
            setCutoff(selected.milliseconds) // Store the date in milliseconds
            setCutoffDateText(selected.label) // Store the label for display
        } else {
            setCutoff(null) // Clear the milliseconds if selection is cleared
            setCutoffDateText(null) // Clear the label if selection is cleared
        }
    }

    const sectorOptionFormatter = createNotReportableOptionFormatter(
        reportability.sector
    )
    const verticalOptionFormatter = createNotReportableOptionFormatter(
        reportability.vertical
    )
    const ownershipOptionFormatter = createNotReportableOptionFormatter(
        reportability.ownership
    )
    const headcountOptionFormatter = createNotReportableOptionFormatter(
        reportability.headcount
    )
    const startupOptionFormatter = createNotReportableOptionFormatter(
        reportability.startup
    )
    const cutoffOptionFormatter = createNotReportableOptionFormatter(
        reportability.cutoff
    )
    const sectorOptionDisabler = createNotReportableOptionDisabler(
        reportability.sector
    )
    const verticalOptionDisabler = createNotReportableOptionDisabler(
        reportability.vertical
    )
    const ownershipOptionDisabler = createNotReportableOptionDisabler(
        reportability.ownership
    )
    const headcountOptionDisabler = createNotReportableOptionDisabler(
        reportability.headcount
    )
    const startupOptionDisabler = createNotReportableOptionDisabler(
        reportability.startup
    )
    const cutoffOptionDisabler = createNotReportableOptionDisabler(
        reportability.cutoff,
        (option) => option?.value
    )

    const updateReportQuestionName = () => {
        for (const value of flatReportOptions) {
            if (reportValue === value['value']) {
                setReportName(value['title'])
                setReportQuestion(value['question'])
            }
        }
    }

    const handleCountryChange = (event) => {
        setCountryValue(event.value)
    }
    const handleReportOptionChange = (event) => {
        setReportValue(event.value)
    }

    const handleYearOptionChange = (event) => {
        if (event === null) {
            setYearValue(undefined)
        } else {
            setYearValue(event.value)
        }
    }

    const handleJobFunctionOptionChange = (event) => {
        if (event === null) {
            setJobFunctionValue(undefined)
        } else {
            setJobFunctionValue(event.value)
        }
    }

    const handleSectorChange = (event) => {
        if (event === null) {
            setSectorValue(undefined)
        } else {
            setSectorValue(event.value)
        }
    }

    const handleVerticalChange = (event) => {
        if (event === null) {
            setVerticalValue(undefined)
        } else {
            setVerticalValue(event.value)
        }
    }

    const handleOwnershipChange = (event) => {
        if (event === null) {
            setOwnershipValue(undefined)
        } else {
            setOwnershipValue(event.value)
        }
    }

    const handleHeadcountChange = (event) => {
        if (event === null) {
            setHeadcountValue(undefined)
        } else {
            setHeadcountValue(event.value)
        }
    }

    const handleStartupChange = (event) => {
        if (event === null) {
            setStartupValue(undefined)
        } else {
            setStartupValue(event.value)
        }
    }
    const ref = useRef()
    const DisplayChart = () => {
        const hdn = !(responseTotal && responseTotal >= MIN_SAMPLE_SIZE)
        const loading =
            typeof responseTotal === 'undefined' || ongoingRequests > 0
        const [divWidth, setDivWidth] = useState(window.innerWidth * 0.6)
        useEffect(() => {
            function handleResize() {
                setDivWidth(ref.current.clientWidth)
            }
            window.addEventListener('resize', handleResize)
        })

        const marginLeft =
            reportValue === 'STI_Choice' ||
            reportValue === 'LTI_Choice' ||
            reportValue == 'Structure' ||
            reportValue == 'AI_usage_status'
                ? 100
                : reportValue === 'AI_use_cases' ||
                  reportValue === 'AI_nonuse_reasons' ||
                  reportValue === 'AI_future_plans'
                ? divWidth < 480
                    ? 450
                    : 500
                : divWidth < 480
                ? 200
                : 280

        const defaultWidth =
            divWidth < 480 ? 480 : divWidth > 900 ? 900 : divWidth
        const width =
            reportValue === 'STI_Choice' ||
            reportValue === 'LTI_Choice' ||
            reportValue == 'Structure' ||
            reportValue == 'AI_usage_status'
                ? defaultWidth - (divWidth < 480 ? 100 : 180)
                : defaultWidth

        let height = 35 * (items.length + 1)
        if (items.length <= 3) {
            height = 70 * (items.length + 1)
        } else if (items.length <= 6) {
            height = 50 * (items.length + 1)
        }

        if (
            reportValue === 'AI_use_cases' ||
            reportValue === 'AI_nonuse_reasons'
        ) {
            height = 45 * (items.length + 1)
            if (items.length <= 3) {
                height = 90 * (items.length + 1)
            } else if (items.length <= 6) {
                height = 75 * (items.length + 1)
            }
        }

        const margin = {
            top: 20,
            right: 70,
            bottom: 30,
            left: marginLeft,
        }

        const transitionTime = 666

        // Initialize an empty array to hold unique genres
        const uniqueGenres = []

        // Iterate through each category's data
        allItems.forEach((item) => {
            item.data.forEach((data) => {
                // Check if the genre is not already in the uniqueGenres array
                if (!uniqueGenres.includes(data.genre)) {
                    uniqueGenres.push(data.genre)
                }
            })
        })

        return (
            <div className="Aligner">
                <div className="chart-div" hidden={hdn}>
                    <svg width={width} height={height}>
                        <XYAxis
                            data={items}
                            width={width}
                            height={height}
                            margin={margin}
                            transitionTime={transitionTime}
                            maxValue={maxPercent}
                        />
                        <Chart
                            data={items}
                            width={width}
                            height={height}
                            margin={margin}
                            transitionTime={transitionTime}
                            maxValue={maxPercent}
                        />
                    </svg>
                    <div className="x-axis-label">Percent of Companies (%)</div>
                </div>
                <div id="loader" hidden={!loading}></div>
                <div hidden={responseTotal !== 'showDataTable' || loading}>
                    {/* i want to display the data from variable allItems in a table*/}
                    <table className="table table-sm">
                        <thead className="thead-style">
                            <tr>
                                {jobFunctionValue === 'All' &&
                                reportValue === STI_TYPE ? (
                                    <th
                                        className="table-first-column-practice"
                                        style={{
                                            backgroundColor: '#003FA3',
                                            color: 'white',
                                            verticalAlign: 'middle',
                                        }}
                                        rowSpan={
                                            reportValue === STI_TYPE ||
                                            reportValue === LTI_TYPE
                                                ? 2
                                                : 1
                                        }
                                    >
                                        {STI_TYPE_COLUMN_NAME}
                                    </th>
                                ) : jobFunctionValue === 'All' &&
                                  reportValue === LTI_TYPE ? (
                                    <th
                                        className="table-first-column-practice"
                                        style={{
                                            backgroundColor: '#003FA3',
                                            color: 'white',
                                            verticalAlign: 'middle',
                                        }}
                                        rowSpan={
                                            reportValue === STI_TYPE ||
                                            reportValue === LTI_TYPE
                                                ? 2
                                                : 1
                                        }
                                    >
                                        {LTI_TYPE_COLUMN_NAME}
                                    </th>
                                ) : yearValue === 'AllYears' ? (
                                    <th
                                        className="table-first-column-practice"
                                        style={{
                                            backgroundColor: '#003FA3',
                                            color: 'white',
                                            verticalAlign: 'middle',
                                        }}
                                        rowSpan={
                                            reportValue === STI_TYPE ||
                                            reportValue === LTI_TYPE
                                                ? 2
                                                : 1
                                        }
                                    >
                                        {STI_BUDGETS_COLUMN_NAME}
                                    </th>
                                ) : (
                                    <th
                                        className="table-first-column-practice"
                                        style={{
                                            backgroundColor: '#003FA3',
                                            color: 'white',
                                            verticalAlign: 'middle',
                                        }}
                                        rowSpan={
                                            reportValue === STI_TYPE ||
                                            reportValue === LTI_TYPE
                                                ? 2
                                                : 1
                                        }
                                    ></th>
                                )}
                                {allItems.map((item) => (
                                    <th
                                        className="table-first-row-practice"
                                        key={item.category}
                                        style={{
                                            backgroundColor: '#003FA3',
                                            color: 'white',
                                            verticalAlign: 'bottom',
                                            borderBottom:
                                                reportValue === STI_TYPE ||
                                                reportValue === LTI_TYPE
                                                    ? 'none'
                                                    : undefined,
                                            paddingBottom:
                                                reportValue === STI_TYPE ||
                                                reportValue === LTI_TYPE
                                                    ? '0px'
                                                    : undefined,
                                        }}
                                    >
                                        <div style={{ whiteSpace: 'pre-wrap' }}>
                                            {item.category}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                            {(reportValue === STI_TYPE ||
                                reportValue === LTI_TYPE) && (
                                <tr>
                                    {allItems.map((item) => (
                                        <th
                                            className="table-first-row-practice"
                                            key={item.category + '_sub'}
                                            style={{
                                                backgroundColor: '#003FA3',
                                                color: 'white',
                                                verticalAlign: 'top',
                                                borderTop: 'none',
                                                paddingTop: '5px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontWeight: 'normal',
                                                    fontSize: '13px',
                                                }}
                                            >
                                                (N={item.responseTotal})
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {uniqueGenres.map((genre, genreIndex) => (
                                <tr key={genreIndex}>
                                    <td
                                        style={{
                                            width:
                                                jobFunctionValue === 'All'
                                                    ? '400px'
                                                    : yearValue === 'AllYears'
                                                    ? '200px'
                                                    : '100px',
                                        }}
                                    >
                                        {genre}
                                    </td>
                                    {allItems.map((item, itemIndex) => {
                                        const dataForGenre = item.data.find(
                                            (data) => data.genre === genre
                                        )
                                        return (
                                            <td
                                                className="table-row-practice"
                                                key={itemIndex}
                                                style={{
                                                    width:
                                                        jobFunctionValue ===
                                                            'All' ||
                                                        yearValue === 'AllYears'
                                                            ? '200px'
                                                            : '100px',
                                                }}
                                            >
                                                {item.responseTotal <
                                                MIN_SAMPLE_SIZE
                                                    ? '*'
                                                    : dataForGenre
                                                    ? `${Number(
                                                          dataForGenre.percent
                                                      ).toFixed(1)}%`
                                                    : '0.00%'}
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                        {tableFooter(survey, 'no', 'no', false, '')}
                    </table>
                </div>
            </div>
        )
    }
    const showResponseTotalText = () => {
        const loading =
            typeof responseTotal === 'undefined' || ongoingRequests > 0
        if (loading) {
            return ''
        } else if (responseTotal === 'showDataTable') {
            return <div></div>
        } else if (responseTotal < MIN_SAMPLE_SIZE) {
            return (
                <p className="practice-data-annotation">{TEXT_NO_AVAIL_DATA}</p>
            )
        } else {
            return (
                <div
                    className="practice-data-annotation"
                    style={{ color: 'black' }}
                >
                    <div className="practice-response-number-text">
                        Number of Responses: {responseTotal.toLocaleString()}
                    </div>
                    <br></br>
                    <div className="practice-survey-source">
                        {SURVEY_COPY_RIGHT[survey]}
                    </div>
                </div>
            )
        }
    }

    if (
        IsValidDataCutSelection(
            sectorValue,
            verticalValue,
            ownershipValue,
            headcountValue,
            startupValue,
            headcountOptions
        ) ||
        (reportValue &&
            flatReportOptions.find((c) => c.value === reportValue) ===
                undefined) ||
        (countryValue &&
            PRACTICE_GROUPED_COUNTRY_OPTIONS[survey]
                .reduce((acc, val) => acc.concat(val.options), [])
                .find((c) => c.value === countryValue) === undefined)
    ) {
        return (
            <div>
                <PageNotFound />
            </div>
        )
    } else {
        return (
            <Container fluid>
                <div className="country-div-container">
                    <Row>
                        <Col
                            sm={12}
                            lg={3}
                            className="pane printHidden"
                            style={!reportValue ? { height: '100vh' } : {}}
                        >
                            <ReactSelect
                                label={TEXT_COUNTRY_SELECTION}
                                placeholder={TEXT_SELECT_PLACEHOLDER}
                                className="react-select form-control p-0"
                                options={
                                    PRACTICE_GROUPED_COUNTRY_OPTIONS[survey]
                                }
                                formatGroupLabel={formatGroupLabel}
                                onChange={handleCountryChange}
                                value={
                                    countryValue
                                        ? PRACTICE_GROUPED_COUNTRY_OPTIONS[
                                              survey
                                          ]
                                              .reduce(
                                                  (acc, val) =>
                                                      acc.concat(val.options),
                                                  []
                                              )
                                              .find(
                                                  (c) =>
                                                      c.value === countryValue
                                              )
                                        : TEXT_SELECT_PLACEHOLDER
                                }
                                closeMenuOnSelect={true}
                            />

                            <ReactSelect
                                label={TEXT_REPORT_SELECTION}
                                placeholder={TEXT_SELECT_PLACEHOLDER}
                                className="react-select form-control p-0"
                                options={reportOptions}
                                formatGroupLabel={
                                    [
                                        SURVEY_YEAR_2026_2027,
                                        SURVEY_YEAR_2027_PRELIM,
                                    ].includes(survey)
                                        ? formatGroupLabel
                                        : undefined
                                }
                                onChange={handleReportOptionChange}
                                value={
                                    reportValue
                                        ? flatReportOptions.find(
                                              (c) => c.value === reportValue
                                          )
                                        : TEXT_SELECT_PLACEHOLDER
                                }
                                closeMenuOnSelect={true}
                                isDisabled={!countryValue}
                                maxMenuHeight="700px"
                            />
                            {reportValue === STI_PERCENT ? (
                                <ReactSelect
                                    label="Select Year:"
                                    placeholder={TEXT_SELECT_PLACEHOLDER}
                                    className="react-select form-control p-0"
                                    options={YEARS}
                                    onChange={handleYearOptionChange}
                                    value={
                                        yearValue
                                            ? YEARS.find(
                                                  (c) => c.value === yearValue
                                              )
                                            : TEXT_SELECT_PLACEHOLDER
                                    }
                                    closeMenuOnSelect={true}
                                />
                            ) : null}

                            {reportValue === STI_TYPE ||
                            reportValue === LTI_TYPE ? (
                                <ReactSelect
                                    label="Select Job Function:"
                                    placeholder={TEXT_SELECT_PLACEHOLDER}
                                    className="react-select form-control p-0"
                                    options={JOB_FUNCTIONS}
                                    onChange={handleJobFunctionOptionChange}
                                    value={
                                        jobFunctionValue
                                            ? JOB_FUNCTIONS.find(
                                                  (c) =>
                                                      c.value ===
                                                      jobFunctionValue
                                              )
                                            : TEXT_SELECT_PLACEHOLDER
                                    }
                                    closeMenuOnSelect={true}
                                />
                            ) : null}

                            <div
                                id="datacuts-filters"
                                style={
                                    reportValue && countryValue
                                        ? { display: 'block' }
                                        : { display: 'none' }
                                }
                            >
                                <p className="report-seperator">
                                    {TEXT_DATA_CUTS_SELECTION}
                                </p>
                                <ReactSelect
                                    className="react-select form-control p-0"
                                    annotation={sectorLabel}
                                    placeholder={TEXT_SELECT_PLACEHOLDER}
                                    options={sectorGroups}
                                    formatGroupLabel={formatGroupLabel}
                                    formatOptionLabel={sectorOptionFormatter}
                                    isOptionDisabled={sectorOptionDisabler}
                                    onChange={handleSectorChange}
                                    value={
                                        sectorValue
                                            ? sectorGroups
                                                  .reduce(
                                                      (acc, val) =>
                                                          acc.concat(
                                                              val.options
                                                          ),
                                                      []
                                                  )
                                                  .find(
                                                      (c) =>
                                                          c.value ===
                                                          sectorValue
                                                  )
                                            : '-'
                                    }
                                    isClearable={true}
                                    closeMenuOnSelect={true}
                                />
                                {isVerticalFilterAvailable && (
                                    <ReactSelect
                                        className="react-select form-control p-0"
                                        annotation={TEXT_INDUSTRY_VERTICAL}
                                        placeholder={TEXT_SELECT_PLACEHOLDER}
                                        options={
                                            DISALLOW_RECENT_SURVEY_SELECTION.includes(
                                                survey
                                            )
                                                ? VERTICALS
                                                : survey ===
                                                      SURVEY_YEAR_2025_2026_PRELIM ||
                                                  survey === SURVEY_YEAR_2025_2026
                                                ? VERTICALS_2025_2026
                                                : VERTICALS_2026
                                        }
                                        formatOptionLabel={verticalOptionFormatter}
                                        isOptionDisabled={verticalOptionDisabler}
                                        onChange={handleVerticalChange}
                                        value={
                                            verticalValue
                                                ? DISALLOW_RECENT_SURVEY_SELECTION.includes(
                                                      survey
                                                  )
                                                    ? VERTICALS.find(
                                                          (c) =>
                                                              c.value ===
                                                              verticalValue
                                                      )
                                                    : survey ===
                                                          SURVEY_YEAR_2025_2026_PRELIM ||
                                                      survey ===
                                                          SURVEY_YEAR_2025_2026
                                                    ? VERTICALS_2025_2026.find(
                                                          (c) =>
                                                              c.value ===
                                                              verticalValue
                                                      )
                                                    : VERTICALS_2026.find(
                                                          (c) =>
                                                              c.value ===
                                                              verticalValue
                                                      )
                                                : TEXT_SELECT_PLACEHOLDER
                                        }
                                        isClearable={true}
                                        closeMenuOnSelect={true}
                                    />
                                )}
                                <ReactSelect
                                    className="react-select form-control p-0"
                                    annotation={TEXT_OWNERSHIP}
                                    placeholder={TEXT_SELECT_PLACEHOLDER}
                                    options={OWNERSHIP_GROUPS}
                                    formatGroupLabel={formatGroupLabel}
                                    formatOptionLabel={ownershipOptionFormatter}
                                    isOptionDisabled={ownershipOptionDisabler}
                                    onChange={handleOwnershipChange}
                                    value={
                                        ownershipValue
                                            ? OWNERSHIP_GROUPS.reduce(
                                                  (acc, val) =>
                                                      acc.concat(val.options),
                                                  []
                                              ).find(
                                                  (c) =>
                                                      c.value === ownershipValue
                                              )
                                            : TEXT_SELECT_PLACEHOLDER
                                    }
                                    isClearable={true}
                                    closeMenuOnSelect={true}
                                />

                                <ReactSelect
                                    className="react-select form-control p-0"
                                    annotation={TEXT_HEADCOUNT}
                                    placeholder={TEXT_SELECT_PLACEHOLDER}
                                    options={headcountOptions}
                                    formatOptionLabel={headcountOptionFormatter}
                                    isOptionDisabled={headcountOptionDisabler}
                                    onChange={handleHeadcountChange}
                                    value={
                                        headcountValue
                                            ? headcountOptions.find(
                                                  (c) =>
                                                      c.value === headcountValue
                                              )
                                            : TEXT_SELECT_PLACEHOLDER
                                    }
                                    isClearable={true}
                                    closeMenuOnSelect={true}
                                />
                                {isStartupFilterAvailable && (
                                    <ReactSelect
                                        className="react-select form-control p-0"
                                        annotation={TEXT_STARTUP}
                                        placeholder={TEXT_SELECT_PLACEHOLDER}
                                        options={STARTUP_OPTIONS}
                                        formatOptionLabel={startupOptionFormatter}
                                        isOptionDisabled={startupOptionDisabler}
                                        onChange={handleStartupChange}
                                        value={
                                            startupValue
                                                ? STARTUP_OPTIONS.find(
                                                      (c) =>
                                                          c.value === startupValue
                                                  )
                                                : TEXT_SELECT_PLACEHOLDER
                                        }
                                        isClearable={true}
                                        closeMenuOnSelect={true}
                                    />
                                )}
                                {DISALLOW_RECENT_SURVEY_SELECTION.includes(
                                    survey
                                ) ? (
                                    <div></div>
                                ) : (
                                    <div>
                                        <ReactSelect
                                            className="react-select form-control p-0"
                                            placeholder="-"
                                            annotation={TEXT_PARTICIPATION}
                                            options={getRecentDateOptions()}
                                            formatOptionLabel={
                                                cutoffOptionFormatter
                                            }
                                            isOptionDisabled={
                                                cutoffOptionDisabler
                                            }
                                            onChange={handleRecentDataChange}
                                            value={
                                                cutoff
                                                    ? getRecentDateOptions().find(
                                                          (c) =>
                                                              c.milliseconds ===
                                                              Number(cutoff)
                                                      )
                                                    : null
                                            }
                                            isClearable={false}
                                            closeMenuOnSelect={true}
                                        />
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col
                            sm={12}
                            lg={9}
                            className="table-area"
                            style={
                                reportValue
                                    ? { display: 'block' }
                                    : { display: 'none' }
                            }
                        >
                            <div className="printVisible">
                                <div className="logo-print-view">
                                    <img src={Logo} alt="" width="238.19"></img>
                                </div>
                            </div>
                            <p className="table-title">{reportName}</p>
                            <hr style={{ width: '100%' }} />{' '}
                            <div>
                                <div className="container">
                                    <p className="practice-data-question">
                                        {reportQuestion}
                                    </p>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            <span className="datacut-type">
                                                {COUNTRY_SELECTED_TEXT}:
                                            </span>
                                        </div>
                                        <div className="col text-start">
                                            {countryValue === 'Global'
                                                ? 'Global: All Countries'
                                                : countryValue}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                yearValue,
                                                YEAR_DATA_CUT_SELECTED_NAME
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                yearValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                jobFunctionValue,
                                                JOB_FUNCTION_DATA_CUT_SELECTED_NAME
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                jobFunctionValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                sectorValue,
                                                sectorLabel
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                sectorValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                verticalValue,
                                                TEXT_INDUSTRY_VERTICAL
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                verticalValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                ownershipValue,
                                                TEXT_OWNERSHIP
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                ownershipValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                headcountValue,
                                                TEXT_HEADCOUNT
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                headcountValue
                                            )}
                                        </div>
                                    </div>
                                    <div className="row g-0 align-items-center">
                                        <div className="col-4 col-xl-3 text-start">
                                            {getDataCutSelectionTextTitle(
                                                startupValue,
                                                TEXT_STARTUP
                                            )}
                                        </div>
                                        <div className="col text-start">
                                            {getDataCutSelectionTextName(
                                                startupValue
                                            )}
                                        </div>
                                    </div>
                                    {cutoff ? (
                                        <div className="row g-0 align-items-center">
                                            <div className="col-4 col-xl-3 text-start">
                                                <span className="datacut-type">
                                                    {TEXT_PARTICIPATION}
                                                </span>
                                            </div>

                                            <div className="col text-start">
                                                {cutoffDateText}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="chart-container" ref={ref}>
                                    {DisplayChart()}
                                </div>

                                <br></br>
                                <div>{showResponseTotalText()}</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        )
    }
}

export default Practice
